import React from 'react';
import styles from '../dentistaencantada/dentistaencantada.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const Dentistaencantada: React.FC = () => {

    return (
        <div className={styles.dentistaencantada}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <h1 className="pt-2 mb-0">Dentista Encantada</h1>
                    <p>Atendimento especializado em bebês e crianças 💕</p>
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://www.instagram.com/dentistaencantada?igsh=MTAyZHhod3BqbGRyaw=="
                            title="INSTAGRAM"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#EC008C",
                                padding: "10px",
                                borderRadius: "100%",
                            }}><InstagramIcon height="32" color="#ffffff" /></div>}
                            colorText="#ffffff"
                        />
                        <LinkPersonalizado7
                            href="https://wa.me/5517991532420?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="WHATSAPP"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#EC008C",
                                padding: "6px",
                                borderRadius: "100%",
                            }}><WhatsappIcon height="40" color="#ffffff" /></div>}
                            colorText="#ffffff"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/vDGauh9zrRxmVzjq7"
                            title="LOCALIZAÇÃO"
                            icon={<div style={{
                                width: "max-content",
                                backgroundColor: "#EC008C",
                                padding: "6px",
                                borderRadius: "100%",
                            }}><MapsIcon height="40" color="#ffffff" /></div>}
                            colorText="#ffffff"
                        />
                    </div>
                </div >
            </div >
        </div >
    );
};

export default Dentistaencantada;
